import * as types from './types';

export const INITIAL_STATE = {
  open: false,
  title: 'Authorize',
  /** Successfully logged in callback */
  onUser: user => {},
  /** Access Prompt will close when successfully logged in */
  closeOnUser: false,
  /** Error callback */
  onError: error => {},
  /** Access Prompt will close if an error occurs */
  closeOnError: false,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.REQUEST_ACCESS:
      return {
        ...state,
        open: true,
        ...payload,
      };
    case types.CLOSE_ACCESS_PROMPT:
      return {
        ...state,
        open: false,
      };
    case types.RESET_ACCESS_PROMPT:
      return INITIAL_STATE;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/common/Components/AccessPrompt/state/reducer.js